import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, Transition as _Transition, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/report/tips.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-686e2278")

_pushScopeId("data-v-686e2278")
const _hoisted_1 = { class: "report" }
const _hoisted_2 = { class: "topbox" }
const _hoisted_3 = { class: "member clearfix" }
const _hoisted_4 = { class: "img fl" }
const _hoisted_5 = { class: "info fl" }
const _hoisted_6 = { class: "name" }
const _hoisted_7 = { class: "info fl" }
const _hoisted_8 = { class: "datainfo" }
const _hoisted_9 = { class: "info" }
const _hoisted_10 = { class: "val" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "name" }, "检测日期", -1)
const _hoisted_12 = { class: "info" }
const _hoisted_13 = { class: "val" }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "name" }, "报告日期", -1)
const _hoisted_15 = { class: "info" }
const _hoisted_16 = { class: "val" }
const _hoisted_17 = /*#__PURE__*/_createVNode("span", null, "%", -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "name" }, "有效数据", -1)
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { class: "card" }
const _hoisted_23 = { class: "title bgblue subpadding" }
const _hoisted_24 = { class: "t" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode("中医脾藏功能态势测评 ")
const _hoisted_26 = { class: "card" }
const _hoisted_27 = { class: "title bgblue subpadding" }
const _hoisted_28 = { class: "t" }
const _hoisted_29 = /*#__PURE__*/_createTextVNode("中医肾藏功能态势测评 ")
const _hoisted_30 = { class: "card" }
const _hoisted_31 = { class: "title bgblue subpadding" }
const _hoisted_32 = { class: "t" }
const _hoisted_33 = /*#__PURE__*/_createTextVNode("中医肝藏功能态势测评 ")
const _hoisted_34 = { class: "card" }
const _hoisted_35 = { class: "title bgblue subpadding" }
const _hoisted_36 = { class: "t" }
const _hoisted_37 = /*#__PURE__*/_createTextVNode("中医心藏功能态势测评 ")
const _hoisted_38 = { class: "skeletonbox" }
const _hoisted_39 = { class: "imeibox clearfix" }
const _hoisted_40 = { class: "version fl" }
const _hoisted_41 = { class: "version fr" }
const _hoisted_42 = { class: "footer clearfix" }
const _hoisted_43 = { class: "main-tips" }
const _hoisted_44 = { style: {"padding":"21px 15px","position":"relative"} }
const _hoisted_45 = { style: {"float":"right","padding":"15px 2px","background-color":"#FFFFFF","width":"50px","height":"1.17em","position":"sticky","top":"0"} }
const _hoisted_46 = { style: {"text-align":"center"} }
const _hoisted_47 = { style: {"padding":"15px 2px","position":"sticky","top":"0","background-color":"#FFFFFF","width":"calc(100% - 50px)","height":"1.17em"} }
const _hoisted_48 = /*#__PURE__*/_createTextVNode("保存为图片")
const _hoisted_49 = { class: "wrapper" }
const _hoisted_50 = { class: "block" }
const _hoisted_51 = /*#__PURE__*/_createTextVNode("正在生成图片中，请稍等...")
const _hoisted_52 = /*#__PURE__*/_createVNode("div", {
  "safe-area-inset-bottom": "",
  style: {"padding-bottom":"2em"}
}, null, -1)
const _hoisted_53 = {
  class: "fixed-fast-container",
  "data-html2canvas-ignore": ""
}
const _hoisted_54 = { class: "report-desc-tag-popup" }
const _hoisted_55 = /*#__PURE__*/_createVNode("div", { class: "report-desc-tag-popup__title" }, "报告标记", -1)
const _hoisted_56 = /*#__PURE__*/_createVNode("div", { class: "report-desc-tag-popup__tips" }, "选择一个状态或事件标签，描述下这份报告。", -1)
const _hoisted_57 = { class: "report-tag-suggest-container" }
const _hoisted_58 = { key: 1 }
const _hoisted_59 = {
  class: "report-tag-list",
  style: {"padding":"12px"}
}
const _hoisted_60 = /*#__PURE__*/_createVNode("div", { class: "report-desc-tag-popup__title" }, "备注", -1)
const _hoisted_61 = { style: {"margin-top":"15px"} }
const _hoisted_62 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("div", { class: "report-desc-tag-popup__tips" }, [
    /*#__PURE__*/_createVNode("img", {
      style: {"width":"15px","height":"15px"},
      src: _imports_0
    }),
    /*#__PURE__*/_createTextVNode(" 维护这个标签或记录可以帮助您更好的完善报告，让顾问为您出具更好的方案和建议。 ")
  ])
], -1)
const _hoisted_63 = /*#__PURE__*/_createTextVNode("保存")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_van_image = _resolveComponent("van-image")
  const _component_van_icon = _resolveComponent("van-icon")
  const _component_van_notice_bar = _resolveComponent("van-notice-bar")
  const _component_van_button = _resolveComponent("van-button")
  const _component_van_swipe_cell = _resolveComponent("van-swipe-cell")
  const _component_ImgCodeVersion82 = _resolveComponent("ImgCodeVersion82")
  const _component_ReportVersion8 = _resolveComponent("ReportVersion8")
  const _component_van_skeleton = _resolveComponent("van-skeleton")
  const _component_PersonInfoToast = _resolveComponent("PersonInfoToast")
  const _component_Disclaimers = _resolveComponent("Disclaimers")
  const _component_van_collapse_item = _resolveComponent("van-collapse-item")
  const _component_van_collapse = _resolveComponent("van-collapse")
  const _component_van_popup = _resolveComponent("van-popup")
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")
  const _component_van_col = _resolveComponent("van-col")
  const _component_van_row = _resolveComponent("van-row")
  const _component_van_sticky = _resolveComponent("van-sticky")
  const _component_van_loading = _resolveComponent("van-loading")
  const _component_van_overlay = _resolveComponent("van-overlay")
  const _component_van_search = _resolveComponent("van-search")
  const _component_van_badge = _resolveComponent("van-badge")
  const _component_van_popover = _resolveComponent("van-popover")
  const _component_van_checkbox = _resolveComponent("van-checkbox")
  const _component_van_checkbox_group = _resolveComponent("van-checkbox-group")
  const _component_van_field = _resolveComponent("van-field")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_van_pull_refresh, {
      modelValue: _ctx.loading,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.loading = $event)),
      onRefresh: _ctx.onRefresh
    }, {
      default: _withId(() => [
        _withDirectives(_createVNode("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _createVNode("div", _hoisted_4, [
                _createVNode(_component_van_image, {
                  round: "",
                  fit: "cover",
                  width: "1.45rem",
                  height: "1.45rem",
                  src: _ctx.heartReportData?.userAvatar || _ctx.avatarDefault
                }, null, 8, ["src"])
              ]),
              _createVNode("div", _hoisted_5, [
                _createVNode("div", _hoisted_6, _toDisplayString(_ctx.heartReportData?.userName || '-'), 1)
              ]),
              _createVNode("div", _hoisted_7, [
                (_ctx.heartReportData.sex)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      (_ctx.heartReportData?.sex != '女')
                        ? (_openBlock(), _createBlock(_component_van_image, {
                            key: 0,
                            src: require('@/assets/img/health/female.png'),
                            class: "sexicon"
                          }, null, 8, ["src"]))
                        : (_openBlock(), _createBlock(_component_van_image, {
                            key: 1,
                            src: require('@/assets/img/health/male.png'),
                            class: "sexicon"
                          }, null, 8, ["src"]))
                    ], 64))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode("div", _hoisted_8, [
              _createVNode("div", _hoisted_9, [
                _createVNode("div", _hoisted_10, _toDisplayString(_ctx.heartReportData?.detectionTime), 1),
                _hoisted_11
              ]),
              _createVNode("div", _hoisted_12, [
                _createVNode("div", _hoisted_13, _toDisplayString(_ctx.heartReportData?.reportTime), 1),
                _hoisted_14
              ]),
              _createVNode("div", _hoisted_15, [
                _createVNode("div", _hoisted_16, [
                  _createTextVNode(_toDisplayString(_ctx.heartReportData?.detectionTimeLength ?
    Number(_ctx.heartReportData.detectionTimeLength).toFixed(2) :
    ''), 1),
                  _hoisted_17
                ]),
                _hoisted_18
              ])
            ])
          ]),
          _createVNode(_Transition, { name: "van-slide-left" }, {
            default: _withId(() => [
              (_ctx.showValidDataNoticeTip && _ctx.heartReportData.detectionTimeLength && _ctx.heartReportData.detectionTimeLength < 80)
                ? (_openBlock(), _createBlock("div", _hoisted_19, [
                    _createVNode(_component_van_swipe_cell, null, {
                      right: _withId(() => [
                        _createVNode(_component_van_button, {
                          style: {"color":"red","border":"0","background-color":"#FFFBEB"},
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showValidDataNoticeTip = false)),
                          square: "",
                          type: "default",
                          icon: "cross"
                        })
                      ]),
                      default: _withId(() => [
                        _createVNode(_component_van_notice_bar, {
                          mode: "closeable",
                          color: "#ED6A0C",
                          background: "#FFFBEB"
                        }, {
                          "right-icon": _withId(() => [
                            _createVNode(_component_van_icon, {
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showMoreTips = true)),
                              name: "question-o",
                              class: "van-badge__wrapper van-icon van-icon-cross van-notice-bar__right-icon"
                            })
                          ]),
                          default: _withId(() => [
                            (_ctx.heartReportData.detectionTimeLength < 60)
                              ? (_openBlock(), _createBlock("span", _hoisted_20, " 当前报告有效数据率过低，评估结果不可靠，请重新测评。 "))
                              : (_ctx.heartReportData.detectionTimeLength < 80)
                                ? (_openBlock(), _createBlock("span", _hoisted_21, " 当前报告有效数据率偏低，评估结果不可靠。 "))
                                : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_ImgCodeVersion82, {
            imgList: _ctx.imgList,
            codeList: _ctx.codeList,
            onShowDescPopup: _ctx.openDescPopup
          }, null, 8, ["imgList", "codeList", "onShowDescPopup"]),
          _createVNode("div", _hoisted_22, [
            _createVNode("div", _hoisted_23, [
              _createVNode("div", _hoisted_24, [
                _hoisted_25,
                _createVNode(_component_van_icon, {
                  style: {"top":"-1px","vertical-align":"middle"},
                  name: "info-o",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openDescPopup({
    title: '中医脾藏功能态势释义',
    content: `中医学中的脾藏(音zàng)是指①消化食物、吸收营养、排泄粪便和少量最终代谢产物的消化系统、消化属动力系统和消化属脉管系统；②主持物质承载、交换、转化和存储的转载系统和转载属脉管系统；③产生凝血因子防止出血的凝血系统，产生抗凝血因子防止血栓形成的抗凝血系统。`,
  })))
                })
              ])
            ]),
            _createVNode(_component_ReportVersion8, { data: _ctx.spleenReportData }, null, 8, ["data"])
          ]),
          _createVNode("div", _hoisted_26, [
            _createVNode("div", _hoisted_27, [
              _createVNode("div", _hoisted_28, [
                _hoisted_29,
                _createVNode(_component_van_icon, {
                  style: {"top":"-1px","vertical-align":"middle"},
                  name: "info-o",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openDescPopup({
    title: '中医肾藏功能态势释义',
    contentIsHtml: true,
    content: `<p>中医肾藏的气化功能是指同化异化系统和产热散热系统主持和表达物质能量代谢的功能。其中，同化异化系统由细胞器、胞内酶、体液、细胞产物和化学能组成；产热散热系统主要由产热结构、散热结构、保热结构和热能组成。</p>
<p>该功能异常时，或表现为不怕冷怕热、喜欢吃凉东西、穿得少盖得少、喜欢冬天不喜欢夏天，中医称为阳热状态；或表现为不怕热怕冷、不敢吃凉东西、穿得多盖得多、喜欢夏天不喜欢冬天、手脚发凉、腰或小腹冷痛，中医称为阴寒状态。</p>
`,
  })))
                })
              ])
            ]),
            _createVNode(_component_ReportVersion8, { data: _ctx.kidneyReportData }, null, 8, ["data"])
          ]),
          _createVNode("div", _hoisted_30, [
            _createVNode("div", _hoisted_31, [
              _createVNode("div", _hoisted_32, [
                _hoisted_33,
                _createVNode(_component_van_icon, {
                  style: {"top":"-1px","vertical-align":"middle"},
                  name: "info-o",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.openDescPopup({
    title: '中医肝藏功能态势释义',
    content: '中医学中的肝藏(音zàng)是指①产生和传导内脏感觉和运动信号支配内脏运动，对外来刺激产生下意识精神活动和内心体验的内脏神经系统、下意识神经系统、情绪神经系统、下意识情绪属动力系统和下意识情绪属脉管系统；②支配和表达躯体运动的躯体神经系统、躯体神经属脉管系统、躯体动力系统和躯体动力属脉管系统。',
  })))
                })
              ])
            ]),
            _createVNode(_component_ReportVersion8, { data: _ctx.liverReportData }, null, 8, ["data"])
          ]),
          _createVNode("div", _hoisted_34, [
            _createVNode("div", _hoisted_35, [
              _createVNode("div", _hoisted_36, [
                _hoisted_37,
                _createVNode(_component_van_icon, {
                  style: {"top":"-1px","vertical-align":"middle"},
                  name: "info-o",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.openDescPopup({
    title: '中医心藏功能态势释义',
    content: '中医学中的心藏(音zàng)是指①产生和表达有意识精神活动（如思维、推理、学习、记忆等）的有意识神经系统和精神属动力系统；②约束和推动血液和淋巴液循行全身的脉管系统、脉管属动力系统和脉管属脉管系统。',
  })))
                })
              ])
            ]),
            _createVNode(_component_ReportVersion8, { data: _ctx.heartReportData }, null, 8, ["data"])
          ])
        ], 512), [
          [_vShow, _ctx.heartReportData]
        ]),
        _withDirectives(_createVNode("div", _hoisted_38, [
          _createVNode(_component_van_skeleton, {
            title: "",
            avatar: "",
            row: 1
          }),
          _createVNode(_component_van_skeleton, {
            title: "",
            row: 5
          }),
          _createVNode(_component_van_skeleton, {
            title: "",
            row: 5
          })
        ], 512), [
          [_vShow, !_ctx.heartReportData]
        ]),
        _createVNode("div", _hoisted_39, [
          _createVNode("div", _hoisted_40, "报告版本：V" + _toDisplayString(8.2), 1),
          _createVNode("div", _hoisted_41, "设备编号：" + _toDisplayString(_ctx.heartReportData?.imei ?? '-'), 1)
        ]),
        _createVNode("div", _hoisted_42, [
          (_ctx.heartReportData?.expertId === '103')
            ? (_openBlock(), _createBlock(_component_PersonInfoToast, {
                key: 0,
                title: "健康报告专家授权：",
                person: "王义国"
              }))
            : (_openBlock(), _createBlock(_component_PersonInfoToast, {
                key: 1,
                title: "健康报告专家授权：",
                person: "张启明"
              }))
        ]),
        _createVNode(_component_Disclaimers, { padding: "0 0.4rem 0.4rem" }),
        _createVNode(_component_van_popup, {
          show: _ctx.showMoreTips,
          "onUpdate:show": _cache[8] || (_cache[8] = ($event: any) => (_ctx.showMoreTips = $event)),
          position: "left",
          class: "popup-tips"
        }, {
          default: _withId(() => [
            _createVNode("div", _hoisted_43, [
              _createVNode(_component_van_collapse, {
                modelValue: _ctx.tipActiveNames,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.tipActiveNames = $event))
              }, {
                default: _withId(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.topicTips, (item, index) => {
                    return (_openBlock(), _createBlock(_component_van_collapse_item, {
                      icon: "info-o",
                      key: index,
                      title: item.title,
                      name: index
                    }, {
                      default: _withId(() => [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.contents, (contentItem, contentIndex) => {
                          return (_openBlock(), _createBlock("div", {
                            key: index + '_' + contentIndex,
                            class: "item-tip"
                          }, [
                            _createVNode("p", {
                              textContent: _toDisplayString(contentItem.content)
                            }, null, 8, ["textContent"])
                          ]))
                        }), 128))
                      ]),
                      _: 2
                    }, 1032, ["title", "name"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _: 1
        }, 8, ["show"])
      ]),
      _: 1
    }, 8, ["modelValue", "onRefresh"]),
    _createVNode(_component_van_popup, {
      show: _ctx.descPopup.show,
      "onUpdate:show": _cache[11] || (_cache[11] = ($event: any) => (_ctx.descPopup.show = $event)),
      position: "bottom",
      style: _ctx.descPopup.styleProp,
      overlay: false,
      "lock-scroll": _ctx.descPopup.configProp.lockScroll,
      round: ""
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_44, [
          _createVNode("div", _hoisted_45, [
            _createVNode(_component_van_row, null, {
              default: _withId(() => [
                (_ctx.descPopup.configProp.closeable)
                  ? (_openBlock(), _createBlock(_component_van_col, {
                      key: 0,
                      offset: "12"
                    }, {
                      default: _withId(() => [
                        _createVNode("div", _hoisted_46, [
                          _createVNode(_component_van_icon, {
                            name: "cross",
                            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.descPopup.show = false)),
                            style: {"transform":"scale(1.3)"}
                          })
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.descPopup.bodys, (body, bodyIndex) => {
            return (_openBlock(), _createBlock(_Fragment, { key: bodyIndex }, [
              _createVNode("div", _hoisted_47, [
                _createVNode(_component_van_row, null, {
                  default: _withId(() => [
                    _createVNode(_component_van_col, {
                      span: "20",
                      offset: "1"
                    }, {
                      default: _withId(() => [
                        (body.parseHtml)
                          ? (_openBlock(), _createBlock("h3", {
                              key: 0,
                              innerHTML: body.title,
                              style: {"margin":"0","font-size":"1.17em","text-overflow":"ellipsis","overflow-x":"hidden","white-space":"nowrap"}
                            }, null, 8, ["innerHTML"]))
                          : (_openBlock(), _createBlock("h3", {
                              key: 1,
                              textContent: _toDisplayString(body.title),
                              style: {"margin":"0","font-size":"1.17em","text-overflow":"ellipsis","overflow-x":"hidden","white-space":"nowrap"}
                            }, null, 8, ["textContent"]))
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024)
              ]),
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(body.contents, (content, contentIndex) => {
                return (_openBlock(), _createBlock(_Fragment, {
                  key: bodyIndex + '_' + contentIndex
                }, [
                  (content.parseHtml)
                    ? (_openBlock(), _createBlock("p", {
                        key: 0,
                        innerHTML: content.content,
                        style: {"color":"#323233","font-weight":"400","line-height":"1.75"}
                      }, null, 8, ["innerHTML"]))
                    : (_openBlock(), _createBlock("p", {
                        key: 1,
                        textContent: _toDisplayString(content.content),
                        style: {"color":"#323233","font-weight":"400","line-height":"1.75"}
                      }, null, 8, ["textContent"]))
                ], 64))
              }), 128))
            ], 64))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["show", "style", "lock-scroll"]),
    _createVNode(_component_van_sticky, {
      "safe-area-inset-bottom": "",
      "data-html2canvas-ignore": ""
    }, {
      default: _withId(() => [
        _createVNode(_component_van_row, null, {
          default: _withId(() => [
            _createVNode(_component_van_col, {
              span: "16",
              offset: "4"
            }, {
              default: _withId(() => [
                _createVNode(_component_van_button, {
                  color: "rgb(159, 102, 204)",
                  "data-html2canvas-ignore": "",
                  onClick: _ctx.saveAsImage,
                  type: "primary",
                  round: false,
                  size: "normal",
                  block: ""
                }, {
                  default: _withId(() => [
                    _hoisted_48
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_van_overlay, { show: _ctx.saveAsImageLoading }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_49, [
          _createVNode("div", _hoisted_50, [
            _createVNode(_component_van_loading, {
              "text-color": "#c9c9c9",
              color: "#0094ff",
              size: "24px"
            }, {
              default: _withId(() => [
                _hoisted_51
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _hoisted_52,
    _createVNode("div", _hoisted_53, [
      _createVNode(_component_van_button, {
        onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.reportDescTagPopup.show = true)),
        class: "button-item",
        icon: "records",
        round: ""
      })
    ]),
    _createVNode(_component_van_popup, {
      onOpen: _ctx.loadReportDescInfo,
      "close-on-click-overlay": false,
      show: _ctx.reportDescTagPopup.show,
      "onUpdate:show": _cache[18] || (_cache[18] = ($event: any) => (_ctx.reportDescTagPopup.show = $event)),
      closeable: "",
      position: "bottom",
      style: { height: '70%' }
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_54, [
          _createVNode("div", null, [
            _hoisted_55,
            _hoisted_56,
            _createVNode("div", _hoisted_57, [
              _createVNode(_component_van_popover, {
                trigger: "manual",
                class: "suggested-list-popover",
                show: _ctx.reportDescTagPopup.showsuggestedList,
                "onUpdate:show": _cache[15] || (_cache[15] = ($event: any) => (_ctx.reportDescTagPopup.showsuggestedList = $event)),
                placement: "bottom"
              }, {
                reference: _withId(() => [
                  _createVNode(_component_van_search, {
                    maxlength: 15,
                    "onUpdate:modelValue": [
                      _ctx.handlerUpdateSearchSymptomTagValue,
                      _cache[14] || (_cache[14] = ($event: any) => (_ctx.reportDescTagPopup.searchValue = $event))
                    ],
                    onFocus: _cache[13] || (_cache[13] = ($event: any) => (_ctx.reportDescTagPopup.searchSuggestedList?.length > 0 && (_ctx.reportDescTagPopup.showsuggestedList = true))),
                    modelValue: _ctx.reportDescTagPopup.searchValue,
                    modelModifiers: { trim: true },
                    placeholder: "请输入搜索症状关键词"
                  }, null, 8, ["onUpdate:modelValue", "modelValue"])
                ]),
                default: _withId(() => [
                  _createVNode("div", {
                    onTouchmove: _withModifiers(($event: any) => (void null), ["stop"]),
                    class: "suggest-list",
                    style: {"max-height":"220px","overflow-y":"auto"}
                  }, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.reportDescTagPopup.searchSuggestedList, (item, index) => {
                      return (_openBlock(), _createBlock("div", {
                        class: "suggest-list__item",
                        key: index,
                        onClick: ($event: any) => (_ctx.handleClickByReportSuggestItem(item))
                      }, [
                        (item.isNew)
                          ? (_openBlock(), _createBlock(_component_van_badge, {
                              key: 0,
                              content: "New"
                            }, {
                              default: _withId(() => [
                                _createVNode("span", null, _toDisplayString(item.label), 1)
                              ]),
                              _: 2
                            }, 1024))
                          : (_openBlock(), _createBlock("span", _hoisted_58, _toDisplayString(item.label), 1))
                      ], 8, ["onClick"]))
                    }), 128))
                  ], 40, ["onTouchmove"])
                ]),
                _: 1
              }, 8, ["show"])
            ]),
            _createVNode("div", _hoisted_59, [
              _createVNode(_component_van_checkbox_group, {
                modelValue: _ctx.reportDescTagPopup.reportSelectedTagNames,
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.reportDescTagPopup.reportSelectedTagNames = $event)),
                direction: "horizontal",
                "checked-color": "#4850c4",
                onChange: _ctx.handleReportTagItem
              }, {
                default: _withId(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.reportDescTagPopup.reportTagItem, (selectItem, selectIndex) => {
                    return (_openBlock(), _createBlock(_component_van_checkbox, {
                      key: selectIndex,
                      name: selectItem.value,
                      shape: "square"
                    }, {
                      icon: _withId(({ checked, disabled }) => [
                        checked
                          ? (_openBlock(), _createBlock(_component_van_button, {
                              key: 0,
                              style: {"min-width":"51px"},
                              size: "normal",
                              disabled: disabled,
                              square: "",
                              color: "#7232dd"
                            }, {
                              default: _withId(() => [
                                _createTextVNode(_toDisplayString(selectItem.label), 1)
                              ]),
                              _: 2
                            }, 1032, ["disabled"]))
                          : (_openBlock(), _createBlock(_component_van_button, {
                              key: 1,
                              style: {"min-width":"51px"},
                              size: "normal",
                              disabled: disabled,
                              square: "",
                              plain: "",
                              color: "#7232dd"
                            }, {
                              default: _withId(() => [
                                _createTextVNode(_toDisplayString(selectItem.label), 1)
                              ]),
                              _: 2
                            }, 1032, ["disabled"]))
                      ]),
                      _: 2
                    }, 1032, ["name"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "onChange"])
            ])
          ]),
          _createVNode("div", null, [
            _hoisted_60,
            _createVNode("div", _hoisted_61, [
              _createVNode(_component_van_field, {
                style: {"border":"1px solid #efefef"},
                modelValue: _ctx.reportDescTagPopup.remark,
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.reportDescTagPopup.remark = $event)),
                rows: "3",
                autosize: { maxHeight: 150, minHeight: 50 },
                maxlength: "500",
                type: "textarea",
                "show-word-limit": "",
                placeholder: "如果上面的标签没有适合，可以用一两句话 简单描述这一天的心情或身体感受。"
              }, null, 8, ["modelValue"])
            ])
          ]),
          _hoisted_62,
          _createVNode("div", null, [
            _createVNode(_component_van_row, null, {
              default: _withId(() => [
                _createVNode(_component_van_col, {
                  span: "20",
                  offset: "2"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_van_button, {
                      block: "",
                      color: "rgb(159, 102, 204)",
                      type: "primary",
                      disabled: _ctx.reportDescTagPopup.saveBtn.disabled,
                      loading: _ctx.reportDescTagPopup.saveBtn.loading,
                      "loading-text": _ctx.reportDescTagPopup.saveBtn.loadingText,
                      onClick: _ctx.saveReportDesc
                    }, {
                      default: _withId(() => [
                        _hoisted_63
                      ]),
                      _: 1
                    }, 8, ["disabled", "loading", "loading-text", "onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["onOpen", "show"])
  ], 64))
})